import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
export const Title = ({ text }) => (React.createElement("div", { className: styles.title, "data-hook": "share-title" }, text));
Title.propTypes = {
    text: PropTypes.string,
};
//# sourceMappingURL=title.js.map